import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect, useState } from 'react'

import StepForm from '../../../../../features/components/Forms/StepForm'

import useHandleFormik from './hooks/useHandleFormik'
import useSubmitExistingLineItem from './hooks/useSubmitExistingLineItem'
import useLineItemFormSteps from './Steps/inventorySteps/useLineItemFormSteps'
import useNoOverlappingGamTargetingValidationState from './hooks/useNoOverlappingGamTargetingValidationState'

import { clearCreateBulkGamLineItems } from '../../../../../modules/actions/googleAdManager'
import { setRightUploadAdData } from '../../../../../modules/actions/rights'

import {
  createBulkGamLineItemsErrorSelector,
  createBulkGamLineItemsIsLoadingSelector,
  createBulkGamLineItemsSelector,
  createBulkGamLineItemsWasCreatedSelector
} from '../../../../../modules/selectors/googleAdManager'
import { LINE_ITEM_FORM } from '../index'
import { GOOGLE_AD_MANAGER_PLATFORM } from '../../../../../constants/selectLists/platformList'
import { LIST_ITEM_OPTION, OPTION_EXISTING_LIST_ITEM } from '../../../../../hooks/formHooks/listItemFormHooks/fields'

const LineItemForm = ({ formProgressItems, onSuccessSubmit }) => {
  const dispatch = useDispatch()

  const [successSubmit, setSuccessSubmit] = useState(false)

  const bulkLineItemsCreatedData = useSelector(createBulkGamLineItemsSelector)
  const bulkLineItemsWasCreated = useSelector(createBulkGamLineItemsWasCreatedSelector)

  const { validationState, updateValidationState, hasTargetingConflicts } =
    useNoOverlappingGamTargetingValidationState()

  const { isExistingLoading, isExistingError, handleExistedLineItemSubmit } = useSubmitExistingLineItem({
    setSuccessSubmit
  })
  const formik = useHandleFormik({ validationState, handleExistedLineItemSubmit })
  const { values } = formik

  const steps = useLineItemFormSteps({
    values,
    onValidationChange: updateValidationState
  })

  const onSuccessSubmitHandler = useCallback(() => {
    onSuccessSubmit()
  }, [onSuccessSubmit])

  const clearCreateBulkLineItemsHandler = useCallback(() => {
    dispatch(clearCreateBulkGamLineItems())
  }, [dispatch])

  useEffect(() => {
    if (bulkLineItemsWasCreated) {
      dispatch(
        setRightUploadAdData(
          {
            lineItem: bulkLineItemsCreatedData[0],
            lineItemsBulkData: bulkLineItemsCreatedData
          },
          GOOGLE_AD_MANAGER_PLATFORM
        )
      )

      setSuccessSubmit(true)
    }
  }, [dispatch, bulkLineItemsWasCreated, bulkLineItemsCreatedData])

  const isLoadingSelector =
    values[LIST_ITEM_OPTION] === OPTION_EXISTING_LIST_ITEM
      ? () => isExistingLoading
      : createBulkGamLineItemsIsLoadingSelector

  const errorSelector =
    values[LIST_ITEM_OPTION] === OPTION_EXISTING_LIST_ITEM ? () => isExistingError : createBulkGamLineItemsErrorSelector

  return (
    <StepForm
      steps={steps}
      formik={formik}
      formName={LINE_ITEM_FORM}
      formProgressItems={formProgressItems}
      submitText="Save and continue"
      onSuccessSubmit={onSuccessSubmitHandler}
      // existing line item form doesn't need to have a clear flow
      clearSubmitHandler={values[LIST_ITEM_OPTION] !== OPTION_EXISTING_LIST_ITEM && clearCreateBulkLineItemsHandler}
      successSubmit={successSubmit}
      errorSelector={errorSelector}
      isLoadingSelector={isLoadingSelector}
      disabled={hasTargetingConflicts}
    />
  )
}

export default LineItemForm
